import { useEffect, useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const EMPTY = { instagram: '', tiktok: '', facebook: '', youtube: '', linkedin: '', x: '', whatsapp: '' };

export const useSocialLinks = () => {
  const [social, setSocial] = useState(EMPTY);

  useEffect(() => {
    axios
      .get(`${BACKEND_URL}/api/public/settings/social`)
      .then((res) => setSocial({ ...EMPTY, ...res.data }))
      .catch(() => setSocial(EMPTY));
  }, []);

  return social;
};

export default useSocialLinks;
